// libs
import React, {useMemo, useState} from 'react';
import { useTranslation } from "react-i18next";
import axios from "../../axios-defaults";
import Skeleton from 'react-loading-skeleton';

//  CSS
import 'react-loading-skeleton/dist/skeleton.css'

// Components
import PageTitle from "../../components/Commons/PageTitle";
import Alert from "../../components/UI/Alerts/Alert";
import Spinner from "../../components/UI/Spinner";
import TankDetails from "../../components/Tanks/TankDetails";
import TankTabs from "../../components/Tanks/Tabs/TankTabs";


const Tank = (props) => {
	const { t, i18n } = useTranslation();

	//////////////////////////////////////////////////////////////////////////////////////////
	// State management //////////////////////////////////////////////////////////////////////
	// Loading and errors
	const [error,setError] = useState(false);
	const [errorDip,setErrorDip] = useState(false);
	const [loading, setLoading] = useState(false);
	const [loadingDip, setLoadingDip] = useState(false);

	// Data
	const [dipDevice, setDipDevice] = useState(null);
	const [tank, setTank] = useState(null);
	//////////////////////////////////////////////////////////////////////////////////////////
	//////////////////////////////////////////////////////////////////////////////////////////


	const getTank = async (id) =>{
		setLoading(true);

		return await axios.get(`/tanks/${parseInt(id)}`)
		.then(response => {
			setLoading(false);
			if (response.data.succeeded){
				return response.data.data
			}
			return null;
		}).catch(error => {
			setLoading(false);
			console.log('[Tank.jsx] Tank error in getTank()',error);
			return null;
		});
	}

	const getTankReadingDevice = async () => {
		if(!tank){ return []; }
		setLoadingDip(true);
		return await axios.get("/tanks/getDipReadingDevices", {
			params: { tankNumberList: [tank.tankId], }
		}).then(response => {
			setLoadingDip(false);
			if (response.data.succeeded){
				return response.data.data;
			}
		}).catch(error => {
			setLoadingDip(false);
			console.log('[Tank.js] DipDevice Ajax error in getTankReadingDevice() ', error)
		});
   }

	useMemo( async () => {
		if (!props.match.params.id) {
			setError(true);
		} else {
			await getTank(props.match.params.id).then(r => {
				if(!r){ setError(true); }
				else{ setTank(r); }
			});
		}
	}, []);
	useMemo( async () => {
		await getTankReadingDevice().then(r => {
			if(!r){ setErrorDip(true); }
			else{
				if(Array.isArray(r) && r.length > 0){
					setDipDevice(r[0]);
				} else {
					setDipDevice(r);
				}
			}
		})
	}, [tank]);

	let title = '';
	if(loading){
		title = t('misc.loading');
	} else {
		if(!tank || error === true){ title = t('errors.error') }
		else if(tank){ title = t('breadcrumbs.tank') + ' : ' + dipDevice.subAccountCode + ' - ' + tank.tankName; }
	}

	return (
		<div className="container container--larger">
			<PageTitle title={ title } />
			{ (error === true) ? (
					<Alert type="danger" item={{
						type: 'danger',
						link: '',
						additionalClasses: 'mt-5',
						customIcon: 'fas fa-exclamation-triangle',
						text: 'tanks.view.error'
					}}/>
			) : '' }
			{ (loading === true && !error) ? (
				<Spinner />
			) : (
				(!error) && (
					(loadingDip === true) ? (
						<>
							<Skeleton height={300} style={{marginTop:"40px",marginBottom:"50px"}}/>
							<div className="row">
								<div className="col-4 col-md-2"><Skeleton height={30} /></div>
								<div className="col-4 col-md-2"><Skeleton height={30} /></div>
								<div className="col-4 col-md-2"><Skeleton height={30} /></div>
								<div className="col-4 col-md-2"><Skeleton height={30} /></div>
							</div>
							<Skeleton height={300} style={{marginTop:"6px"}}/>
						</>
					) : (
						(errorDip === true) ? (
							<Alert type="danger" item={{
								type: 'danger',
								link: '',
								additionalClasses: 'mt-5',
								customIcon: 'fas fa-exclamation-triangle',
								text: 'tanks.view.error_dip'
							}}/>
						) : (dipDevice) ? (
							<>
								<div className="messages mt-4">
									<Alert type="warning" item={{
										type: '',
										additionalClasses: 'message--condensed',
										customIcon: 'fas fa-clock',
										text: 'tanks.notice_delay'
									}}/>
								</div>
								<TankDetails tank={tank} readingDevice={dipDevice} />
								<TankTabs tank={tank} readingDevice={dipDevice} />
							</>
						) : ''
					)
				)
			) }
		</div>
	);
};

export default Tank;
